export default "__VITE_ASSET__DUmtnQZc__"